import { render, staticRenderFns } from "./advanced-knowledge.vue?vue&type=template&id=5f62542e&scoped=true"
import script from "./advanced-knowledge.vue?vue&type=script&lang=js"
export * from "./advanced-knowledge.vue?vue&type=script&lang=js"
import style0 from "./advanced-knowledge.vue?vue&type=style&index=0&id=5f62542e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f62542e",
  null
  
)

export default component.exports